import { render, staticRenderFns } from "./LevelDecrements.vue?vue&type=template&id=057c3b3a&"
import script from "./LevelDecrements.vue?vue&type=script&lang=js&"
export * from "./LevelDecrements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports